import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import './styles.css';
import type { Props } from './types';

/**
 * The caret on a rail entry that folds its second level — the open page's sections — away and
 * back. It is a sibling of the entry's link rather than inside it, since a button cannot live in
 * an `<a>`; callers lay it over the end of the row.
 */
const NavSubItemsToggle = ({ collapsed, onToggle, className = '' }: Props) => (
  <button
    type="button"
    onClick={onToggle}
    aria-expanded={!collapsed}
    aria-label={collapsed ? 'Show page sections' : 'Hide page sections'}
    className={`flex h-6 w-6 items-center justify-center rounded text-gray-600 hover:bg-gray-200 hover:text-gray-700 dark:hover:bg-gray-600 dark:hover:text-gray-100 ${className}`}>
    <FontAwesomeIcon
      aria-hidden="true"
      className={`h-3 w-3 transition-transform ${collapsed ? '-rotate-90' : ''}`}
      icon={faChevronDown}
    />
  </button>
);

export default React.memo(NavSubItemsToggle);
